// extracted by mini-css-extract-plugin
export default {"container":"Compass_container__1HMjb","content":"Compass_content__tOgnK"};